import React, { useState } from 'react'
import { Wrapper, ColDetail } from './style.css'
import { CSSTransition } from 'react-transition-group'

import Textos from '../data'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { ChevronRightIcon } from '@primer/octicons-react'

const groupBy = (list, props) => {
  return list.reduce((a, b) => {
    ;(a[b[props]] = a[b[props]] || []).push(b)
    return a
  }, {})
}

const Item = ({
  trimestres,
  trimestre,
  innerRef,
  comunasAfectadas,
  triggerMapChange,
  resetMapView,
}) => {
  // console.log('trimestres', trimestres)
  // console.log('trimestre', trimestre)
  const trimestreTitulo = texto => {
    return `${
      texto.endsWith('4')
        ? 'Cuarto Trimestre'
        : texto.endsWith('3')
        ? 'Tercer Trimestre'
        : texto.endsWith('2')
        ? 'Segundo Trimestre'
        : texto.endsWith('0')
        ? 'Anterior al'
        : 'Primer Trimestre'
    } ${texto.split('-')[0]} `
  }

  const dateParser = aDate => {
    const parsedDate = Date.parse(aDate)
    return format(parsedDate, 'dd MMM yyyy', { locale: es })
  }

  const causasFormatter = causas => {
    return causas.length > 1 ? `${causas.length} Causas` : `1 Causa`
  }

  const comunasAfectadasFormatter = comunas => {
    return comunas > 1 ? `${comunas} comunas afectadas` : `Una comuna afectada`
  }

  const duration = 1000

  const [open, setOpen] = useState(false)
  const [data, setData] = useState({})

  const handleToggle = () => {
    console.log('toggling!!')
    resetMapView()
    setOpen(false)
    setTimeout(() => setData({}), 500)
  }

  const handleClick = nodes => {
    console.log('triggering!!', nodes)
    triggerMapChange(nodes)
    // setOpen(true)
    setData(nodes)
  }

  const trimestreGrouped = groupBy(trimestres[trimestre], 'slugComuna')
  // console.log('trimestreGrouped', trimestreGrouped)
  return (
    <Wrapper ref={innerRef}>
      <CSSTransition in={open} timeout={duration} classNames="wrap">
        <div className="slide-wrap">
          <div className="panel">
            <h2 className="p-6 pb-0 text-2xl leading-tight font-inter">
              {trimestreTitulo(trimestre)}
            </h2>
            <div className="p-6">
              <Textos trimestre={trimestre} />
            </div>
            <hr className="mx-6 mb-6" />
            <h3 className="px-6 text-base font-bold tracking-wide uppercase font-inter">
              {causasFormatter(trimestres[trimestre])} <br />
              {comunasAfectadasFormatter(comunasAfectadas)}
            </h3>

            {Object.keys(trimestreGrouped)
              .sort(
                (a, b) =>
                  trimestreGrouped[b].length - trimestreGrouped[a].length,
              )
              .map(comuna => {
                const comunaData = trimestreGrouped[comuna]
                return (
                  <button
                    key={`${trimestre}-${comuna}`}
                    onClick={() => handleClick(comunaData)}
                    className="grid items-center w-full grid-cols-12 px-6 pt-4 pb-6 text-left transition-all outline-none cursor-pointer focus:outline-none hover:bg-grishover font-inter">
                    <span className="col-span-10 text-base text-grisnegro">
                      {comunaData.length}{' '}
                      {comunaData.length > 1 ? 'causas ' : 'causa '} en{' '}
                      <strong>{comunaData[0].comuna}</strong>
                    </span>
                    <span className="text-right">
                      <ChevronRightIcon size={16} />
                    </span>
                  </button>
                )
              })}
          </div>
        </div>
      </CSSTransition>
    </Wrapper>
  )
}

export default Item
